(()=>{
  const init=(scope=document)=>{
    scope.querySelectorAll('[data-kpr-category-browser]').forEach(browser=>{
      if(browser.dataset.kprCategoryReady==='true')return;
      browser.dataset.kprCategoryReady='true';
      const tabs=[...browser.querySelectorAll('[data-kpr-category-tab]')];
      const panels=[...browser.querySelectorAll('[data-kpr-category-panel]')];
      const viewAll=browser.querySelector('[data-kpr-category-view-all]');
      const prev=browser.querySelector('[data-kpr-category-prev]');
      const next=browser.querySelector('[data-kpr-category-next]');
      if(!tabs.length||!panels.length)return;
      const activePanel=()=>panels.find(panel=>!panel.hidden);
      const activeTrack=()=>activePanel()?.querySelector('[data-kpr-category-track]');
      const updateArrows=()=>{
        const track=activeTrack();
        if(!track){if(prev)prev.disabled=true;if(next)next.disabled=true;return}
        const canScroll=track.scrollWidth>track.clientWidth+2;
        if(prev)prev.disabled=!canScroll||track.scrollLeft<=2;
        if(next)next.disabled=!canScroll||track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
      };
      const activate=(id,focus=false)=>{
        tabs.forEach(tab=>{
          const active=tab.dataset.kprCategoryTab===id;
          tab.classList.toggle('is-active',active);
          tab.setAttribute('aria-selected',active?'true':'false');
          tab.tabIndex=active?0:-1;
          if(active&&viewAll)viewAll.href=tab.dataset.url||'#';
        });
        panels.forEach(panel=>{panel.hidden=panel.dataset.kprCategoryPanel!==id});
        const track=activeTrack();
        if(track)track.scrollLeft=0;
        requestAnimationFrame(updateArrows);
        if(focus)tabs.find(tab=>tab.dataset.kprCategoryTab===id)?.focus();
      };
      const scrollByCard=dir=>{
        const track=activeTrack();
        if(!track)return;
        const card=track.querySelector('.kpr-category-products__item');
        const gap=parseFloat(getComputedStyle(track).gap)||0;
        const amount=(card?.getBoundingClientRect().width||track.clientWidth*.8)+gap;
        track.scrollBy({left:dir*amount,behavior:'smooth'});
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>activate(tab.dataset.kprCategoryTab));
        tab.addEventListener('keydown',e=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
          e.preventDefault();
          let target=index;
          if(e.key==='ArrowRight')target=(index+1)%tabs.length;
          if(e.key==='ArrowLeft')target=(index-1+tabs.length)%tabs.length;
          if(e.key==='Home')target=0;
          if(e.key==='End')target=tabs.length-1;
          activate(tabs[target].dataset.kprCategoryTab,true);
        });
      });
      panels.forEach(panel=>panel.querySelector('[data-kpr-category-track]')?.addEventListener('scroll',()=>requestAnimationFrame(updateArrows),{passive:true}));
      prev?.addEventListener('click',()=>scrollByCard(-1));
      next?.addEventListener('click',()=>scrollByCard(1));
      window.addEventListener('resize',updateArrows,{passive:true});
      const initial=tabs.find(tab=>tab.classList.contains('is-active'))||tabs[0];
      activate(initial.dataset.kprCategoryTab);
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init(),{once:true}):init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();